import Button from '@mui/material/Button';

export default function CallButton({ phone, label = 'Call' }: any) {
  console.log('>>>>', typeof phone, phone)
  return (
    <Button
      variant="contained"
      color="primary"
      disabled={typeof phone === 'undefined'}
      href={`tel:${phone}`}
      sx={{
        color: '#fff',
        '&:hover': { color: '#fff' },
        '&:active': { color: '#fff' },
        '&:focus': { color: '#fff' },
        '&:disabled': { color: '#fff' },
      }}
    >
      {label}
    </Button>
  )
}
